// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GFqT","newExpiryDate":"styles_newExpiryDate__3WqvW","footer":"styles_footer__3oke1"};